import React, { useContext } from 'react';
import { ListGroup } from 'react-bootstrap';
import { observer } from 'mobx-react-lite';
import { Context } from '../index';

const TypeBar = observer(() => {
    const { device } = useContext(Context);

    console.log('🔄 TypeBar: количество типов =', device.types.length);
    console.log('🔄 TypeBar: типы =', device.types);

    return (
        <ListGroup>
            {device.types.map(type => (
                <ListGroup.Item
                    key={type.id}
                    style={{ cursor: 'pointer' }}
                    active={type.id === device.selectedType.id}
                    onClick={() => {
                        device.setSelectedType(type);
                        device.setPage(1);
                    }}
                >
                    {type.name}
                </ListGroup.Item>
            ))}
        </ListGroup>
    );
});

export default TypeBar;